// extracted by mini-css-extract-plugin
module.exports = {"titlePromotion":"styles_titlePromotion__3Sukl"};